import MojitoModules from 'mojito/modules';

const SelectionButtonTypes = MojitoModules.SelectionButton.types;

export default {
    GenericMarketContent: {
        layoutDescriptors: {
            types: {
                CS04: {
                    selectionsHeaderContent: 'participant',
                },
                CS6O: {
                    selectionsHeaderContent: 'participant',
                },
                CSFI: {
                    selectionsHeaderContent: 'participant',
                },
                CSFT: {
                    selectionsHeaderContent: 'participant',
                },
                CSH2: {
                    selectionsHeaderContent: 'participant',
                },
                CSHT: {
                    selectionsHeaderContent: 'participant',
                },
                CSOT: {
                    selectionsHeaderContent: 'participant',
                },
                P1CS: {
                    selectionsHeaderContent: 'participant',
                },
                P2CS: {
                    selectionsHeaderContent: 'participant',
                },
            },
        },
    },
    HandicapMarketContent: {
        genericMarketContent: {
            layoutDescriptors: {
                types: {
                    HCOT: {
                        _desktop_selectionNameDisplay: SelectionButtonTypes.NAME_DISPLAY.SHOW,
                    },
                    FHOT: {
                        _desktop_selectionNameDisplay: SelectionButtonTypes.NAME_DISPLAY.SHOW,
                    },
                    AHHT: {
                        _desktop_selectionNameDisplay: SelectionButtonTypes.NAME_DISPLAY.SHOW,
                    },
                    FAHT: {
                        _desktop_selectionNameDisplay: SelectionButtonTypes.NAME_DISPLAY.SHOW,
                    },
                    FA1P: {
                        _desktop_selectionNameDisplay: SelectionButtonTypes.NAME_DISPLAY.SHOW,
                    },
                    T1HC: {
                        _desktop_selectionNameDisplay: SelectionButtonTypes.NAME_DISPLAY.SHOW,
                    },
                    FT1H: {
                        _desktop_selectionNameDisplay: SelectionButtonTypes.NAME_DISPLAY.SHOW,
                    },
                    AH2O: {
                        _desktop_selectionNameDisplay: SelectionButtonTypes.NAME_DISPLAY.SHOW,
                    },
                    FA2P: {
                        _desktop_selectionNameDisplay: SelectionButtonTypes.NAME_DISPLAY.SHOW,
                    },
                    T2HC: {
                        _desktop_selectionNameDisplay: SelectionButtonTypes.NAME_DISPLAY.SHOW,
                    },
                    FT2H: {
                        _desktop_selectionNameDisplay: SelectionButtonTypes.NAME_DISPLAY.SHOW,
                    },
                    FA3P: {
                        _desktop_selectionNameDisplay: SelectionButtonTypes.NAME_DISPLAY.SHOW,
                    },
                    T3HC: {
                        _desktop_selectionNameDisplay: SelectionButtonTypes.NAME_DISPLAY.SHOW,
                    },
                    FT3H: {
                        _desktop_selectionNameDisplay: SelectionButtonTypes.NAME_DISPLAY.SHOW,
                    },
                    FA4P: {
                        _desktop_selectionNameDisplay: SelectionButtonTypes.NAME_DISPLAY.SHOW,
                    },
                    T4HC: {
                        _desktop_selectionNameDisplay: SelectionButtonTypes.NAME_DISPLAY.SHOW,
                    },
                    FT4H: {
                        _desktop_selectionNameDisplay: SelectionButtonTypes.NAME_DISPLAY.SHOW,
                    },
                    FHOU: {
                        _desktop_selectionNameDisplay: SelectionButtonTypes.NAME_DISPLAY.SHOW,
                    },
                },
            },
        },
    },
    SportEventPage: {
        enableMatchAccaBuilder: false,
    },
    DefaultBetContent: {
        marketSwitchItemsOverride: {
            HHTT: '$BETSLIP.PITCHER_MARKETS.ACTION',
            HHPT: '$BETSLIP.PITCHER_MARKETS.HOME_PITCHER_START',
            HHTP: '$BETSLIP.PITCHER_MARKETS.AWAY_PITCHER_START',
            HHPP: '$BETSLIP.PITCHER_MARKETS.BOTH_PITCHERS_START',
        },
    },
};
